import { Outlet, createFileRoute } from "@tanstack/react-router";

import PublicLayout from "../pages/public/component";

export const Route = createFileRoute("/__public")({
  component: () => (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ),
});
